<div class="app-select-wrapper">
    <p-select #selectComponent [(ngModel)]="value" [options]="displayOptions()" [optionLabel]="optionLabel()"
        [optionValue]="optionValue()" [optionDisabled]="optionDisabled()" [placeholder]="placeholderText()"
        [disabled]="selectConfig().disabled || false" [filter]="!!(selectConfig().filter && selectConfig().searchable)"
        [filterPlaceholder]="searchPlaceholderText()"
        [showClear]="!!(selectConfig().showClear && selectConfig().clearable)" [loading]="isLoading()"
        [virtualScroll]="selectConfig().virtualScroll" [virtualScrollItemSize]="selectConfig().virtualScrollItemSize"
        [appendTo]="selectConfig().appendTo" [style]="selectConfig().style" [styleClass]="selectConfig().styleClass"
        [panelStyle]="selectConfig().panelStyle" [panelStyleClass]="selectConfig().panelStyleClass"
        (onChange)="handleChange($event)" (onFilter)="onSearchInput($event)" (onShow)="handleShow()"
        (onHide)="handleHide()" (onClear)="handleClear()">
        <!-- Custom item template -->
        <ng-template pTemplate="item" let-option>
            <ng-container *ngIf="itemTemplate(); else defaultItem">
                <ng-container *ngTemplateOutlet="itemTemplate()!; context: { $implicit: option }"></ng-container>
            </ng-container>
            <ng-template #defaultItem>
                <div class="w-full cursor-pointer transition-all duration-200 rounded-base hover:bg-gray-100"
                    [class.opacity-50]="option.disabled">
                    <div class="flex items-center gap-3 p-2.5 w-full">
                        <div class="flex-1 flex items-center gap-2 min-w-0">
                            <app-icon *ngIf="option.icon" [type]="option.icon" [source]="option.iconSource || 'svg'"
                                [size]="option.iconSize || 'default'" [class]="option.iconClass" />
                            <span class="font-medium text-sm text-gray-900 truncate max-w-[15.625rem]">{{ option.label }}</span>
                        </div>
                    </div>
                </div>
            </ng-template>
        </ng-template>

        <!-- Custom selected item template -->
        <ng-template pTemplate="selectedItem" let-option>
            <ng-container *ngIf="selectedItemTemplate(); else defaultSelectedItem">
                <ng-container
                    *ngTemplateOutlet="selectedItemTemplate()!; context: { $implicit: option }"></ng-container>
            </ng-container>
            <ng-template #defaultSelectedItem>
                <div *ngIf="option" class="flex items-center gap-2 border-none bg-transparent">
                    <app-icon *ngIf="option.icon" [type]="option.icon" [source]="option.iconSource || 'svg'"
                        [size]="option.iconSize || 'default'" [class]="option.iconClass" />
                    <span class="font-medium text-sm text-gray-900">{{ option.label }}</span>
                </div>
            </ng-template>
        </ng-template>

        <!-- Custom header template -->
        <ng-template pTemplate="header" *ngIf="headerTemplate()">
            <ng-container *ngTemplateOutlet="headerTemplate()!"></ng-container>
        </ng-template>

        <!-- Custom footer template for load more or infinite scroll -->
        <ng-template pTemplate="footer">
            <ng-container *ngIf="footerTemplate(); else defaultFooter">
                <ng-container *ngTemplateOutlet="footerTemplate()!"></ng-container>
            </ng-container>
            <ng-template #defaultFooter>
                <div *ngIf="isLoading()" class="p-2 text-center">
                    <i class="pi pi-spinner pi-spin text-arena-blue"></i>
                    <span class="ml-2 text-sm text-gray-600">Loading...</span>
                </div>
            </ng-template>
        </ng-template>

        <!-- Custom empty template -->
        <ng-template pTemplate="empty">
            <ng-container *ngIf="emptyTemplate(); else defaultEmpty">
                <ng-container *ngTemplateOutlet="emptyTemplate()!"></ng-container>
            </ng-container>
            <ng-template #defaultEmpty>
                <div class="p-4 text-center text-gray-500">
                    <i class="pi pi-info-circle text-2xl mb-2"></i>
                    <p class="text-sm">
                        {{ searchQuery() ? 'No results found' : 'No options available' }}
                    </p>
                </div>
            </ng-template>
        </ng-template>
    </p-select>
</div>